<template>
  <div>
    <Main />
  </div>
</template>

<script>
import Main from "../../canadas/deptos/mapLocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
